<!-- <p>dashboard-linear-gauge works!</p> -->
<div *ngIf="creating && panelData" #mainlinear class="main-linear" id="linear_{{panelData.id}}">
    <div class="text-panel-title alignRow">
        <span>{{(panelData.title || panelData.nodeData.Name)}} </span>
        <mat-icon [matMenuTriggerFor]="titleMenu" [matMenuTriggerData]="{panelData: panelData}">edit</mat-icon>
    </div>

    <div class="gauge-item-container">
        <div class="title-item" *ngFor="let datapoint of panelData.datapoints; let idx = index">
            <span class="_dp-name alignRow alignColumn">{{datapoint.DPTitle}}</span>
            <div class="gauge-item">
                <ejs-lineargauge class="_linear-gauge" #linearGauge *ngIf="axes.length > 0" style="margin: auto;"
                    animationDuration=0 #linearMultiple [titleStyle]='titleStyle' [height]="gaugeHeight" height="100%"
                    width="100%" [width]="gaugeWidth" background='transparent' orientation='Horizontal'
                    [axes]='axes[idx]'>
                </ejs-lineargauge>
            </div>
        </div>
    </div>
</div>

<div *ngIf="creating && !panelData" #mainlinear class="main-linear" id="linear_0">
    <div class="text-panel-title alignRow">
        <span>Linear Gauge</span>
    </div>
    <div class="gauge-item alignRow" style="height: 100%;">
        <span class="_dp-name">Example DataPoint</span>
        <ejs-lineargauge height="100%" class="_linear-gauge" #linearGauge style="margin: auto;" animationDuration=0
            [titleStyle]='titleStyle' background='transparent' orientation='Horizontal' [annotations]="annotation">
            <e-axes>
                <e-axis minimum="0" maximum="100">
                    <e-ranges>
                        <e-range start="0" end="30" color="green"></e-range>
                        <e-range start="30" end="70" color="orange"></e-range>
                        <e-range start="70" end="100" color="red"></e-range>
                    </e-ranges>
                    <e-pointers>
                        <e-pointer value="65"></e-pointer>
                    </e-pointers>
                </e-axis>
            </e-axes>
        </ejs-lineargauge>
    </div>
</div>

<div *ngIf="!creating && publicPanelData[panelData.id]" #mainlinear class="main-linear" id="linear_{{panelData.id}}">
    <div class="text-panel-title alignRow">
        <span>{{!publicPanelData[panelData.id] ? 'Loading...' : panelData.title || panelData.nodeData.Name}}</span>
    </div>
    <div class="gauge-item-container">
        <div class="title-item" *ngFor="let datapoint of panelData.datapoints; let idx = index">
            <div class="_dp-name alignRow alignColumn">
                <span>{{datapoint.DPTitle}}</span>
            </div>
            <div class="gauge-item">
                <ejs-lineargauge height="100%" width="100%" class="_linear-gauge" #linearGauge style="margin: auto;"
                    animationDuration=0 [titleStyle]='titleStyle' background='transparent' orientation='Horizontal'>
                    <e-axes>
                        <e-axis
                            [minimum]="publicPanelData[panelData.id] ? Math.min(publicPanelData[panelData.id].min ?? 999, axes[idx][0].minimum) : axes[idx][0].minimum"
                            [maximum]="publicPanelData[panelData.id] ? Math.max(publicPanelData[panelData.id].max ?? 999, axes[idx][0].maximum) : axes[idx][0].maximum"
                            [ranges]="axes[idx][0].ranges" [majorTicks]="{height: 30}">
                            <e-pointers>
                                <e-pointer
                                    *ngIf="publicPanelData && publicPanelData.length > 0 && publicPanelData[panelData.id]"
                                    [value]="publicPanelData[panelData.id].numberMetrics[idx]" 
                                    [color]="resolveRangeColour(publicPanelData[panelData.id] ? publicPanelData[panelData.id].numberMetrics[idx] : 0, idx)"></e-pointer>
                            </e-pointers>
                            <e-annotations>
                                <e-annotation
                                    *ngIf="publicPanelData && publicPanelData.length > 0 && publicPanelData[panelData.id]"
                                    [axisIndex]="0" [axisValue]="publicPanelData[panelData.id].numberMetrics[idx]"
                                    content="<div style='font-size: large; font-weight: bold;'>{{publicPanelData[panelData.id].numberMetrics[idx]}}</div>"
                                    [zIndex]="999" [x]="0" [y]="35">
                                </e-annotation>
                            </e-annotations>
                        </e-axis>
                    </e-axes>
                </ejs-lineargauge>
            </div>
        </div>
    </div>
</div>

<div *ngIf="!creating && !publicPanelData[panelData.id]" class="spinner alignColumn">
    <img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/circle-lines.gif">
</div>